import { CartBlockedIcon } from '@modules/CustomIcons'
import { Col, Divider, Row, Space, Switch, Typography } from 'antd'
import { t } from 'i18next'
import React from 'react'
import style from './blockSwitch.module.scss'
import LimitInfoRow from '../limitInfoRow/LimitInfoRow'
import CardTypeInfo from '../../cardTypeInfo/CardTypeInfo'
import {
  limitsCardApi,
  useFetchCardLimitsQuery,
  useFetchCheckCardMutation,
} from 'store/reducers/limitsforBusinnesCard/cardLimits.api'
import { useAppSelector } from '@shared/hooks/useAppSelector'
import { ModalProvider } from '@shared/Modal'
import CardBlockConfirm from './CardBlockConfirm'
import BeatLoader from '@shared/BeatLoader/BeatLoader'
import { useDispatch } from 'react-redux'

function BlockedCardSwitch() {
  const pan = useAppSelector((state) => state.employeePan.pan)
  const { data, isFetching } = useFetchCardLimitsQuery(pan)
  const dispatch = useDispatch()
  const isNotBlocked = !data?.generInfo?.isBlocked
  const [_, { data: checkData, reset, isSuccess }] = useFetchCheckCardMutation({
    fixedCacheKey: 'FetchCheckCardMutation',
  })

  const datas = [
    {
      title: t('businessCards.cardHolderName'),
      value: data?.generInfo?.cardHolderFullName,
    },
    {
      title: t('businessCards.cardNumber'),
      value: data?.generInfo?.pan,
    },
    {
      title: t('businessCards.expiryDate'),
      value: data?.generInfo?.expDate,
    },
    {
      title: t('businessCards.cardCurrency'),
      value: data?.generInfo?.accCurr,
    },
  ]
  return isFetching ? (
    <BeatLoader />
  ) : (
    <Row justify={'space-between'} className={style['card-container']}>
      <Col span={16} className={style['visa_card_image_div']}>
        <CardTypeInfo
          cardType={data?.generInfo.paymSys}
          text={data?.generInfo.name}
        />
      </Col>
      <Col span={8} className={style['block-toggle']}>
        <Space style={{ display: 'block' }}>
          <Typography.Text> {t('businessCards.blockCard')}</Typography.Text>
          <div className={style['status_main_div']}>
            <CartBlockedIcon />
            {isNotBlocked ? (
              <Typography.Text className={style['unblocked']}>
                {t('businessCards.isnotBlocked')}
              </Typography.Text>
            ) : (
              <Typography.Text className={style['blocked']}>
                {t('businessCards.isBlocked')}
              </Typography.Text>
            )}
          </div>
        </Space>

        <ModalProvider
          title={t('common.attention')}
          centered
          width={500}
          footer={null}
          modalContent={<CardBlockConfirm data={data} />}
          afterClose={() => {
            const isClose =
              isSuccess &&
              !(
                !isNotBlocked &&
                !checkData?.startBlockUpd &&
                checkData?.startDirectorByDocType
              )

            if (isClose) {
              dispatch(limitsCardApi.util.resetApiState())
              reset()
            }
          }}
        >
          {({ openModal }) => (
            <Switch
              className={
                isNotBlocked ? style['switch'] : style['switch-checked']
              }
              checked={!isNotBlocked}
              onChange={() => openModal('')}
            />
          )}
        </ModalProvider>
      </Col>
      <Divider className={style['custom-divider']} />
      <LimitInfoRow data={datas} />
    </Row>
  )
}

export default BlockedCardSwitch
